import { render } from "./CxRelatedEntitiesPanel.vue?vue&type=template&id=791570d5"
import script from "./CxRelatedEntitiesPanel.vue?vue&type=script&lang=js"
export * from "./CxRelatedEntitiesPanel.vue?vue&type=script&lang=js"

import "./CxRelatedEntitiesPanel.vue?vue&type=style&index=0&id=791570d5&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__